import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Modal,
  Tab,
  Tabs,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useLayoutEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bookingOptions } from '../../../../../../constants/HotelServicesConst';
import CustomActiveInactiveRadio from '../../../../../../shared/form-controls/custom-active-inactive-radio/Custom-Active-Inactive-Radio';
import CustomSelect from '../../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import { formDataValidate } from '../../../../../../utils/formUtils';
import { createOrUpdateSpaReservation } from '../../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import {
  fetchIntegrationStatus,
  fetchSpaList,
  fetchSpaReservationConfigs,
  spaReservationConfigsSelector,
  spaSelector,
} from '../../../../configurationSlice';
import { updateSpaSyncConfigs } from '../../../../../../utils/PropertyAPIUtils';
import {
  allPropertyConfigsSelector,
  fetchAllPropertyConfigData,
} from '../../../../../property/propertySlice';
import './SpaReservation.scss';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';

const SpaReservation = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const spas = useSelector(spaSelector);
  const spaConfigList = useSelector(spaReservationConfigsSelector);
  const configuredSpas = spaConfigList.length > 0 && spaConfigList.filter((spa) => spa.pos.active);
  const [currData, setCurrData] = useState({});
  const [tabValue, setTabValue] = useState(0);
  const propertyConfigs = useSelector(allPropertyConfigsSelector);

  useEffect(() => {
    if (!selectedHotel) return;
    dispatch(fetchIntegrationStatus(selectedHotel));
    dispatch(fetchSpaList(selectedHotel));
    dispatch(fetchSpaReservationConfigs(selectedHotel));
  }, [selectedHotel]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '52%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: 700,
    bgcolor: 'white',
    borderRadius: '20px',
    border: 'none',
    p: 4,
    outline: 'none',
    overflow: 'auto',
  };

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    spaSelected: {
      value: '',
      fieldName: 'Select Spa',
      errors: {},
      validations: ['required'],
    },
    integrationSource: {
      value: '',
      fieldName: 'Integration Source',
      errors: {},
      validations: [],
    },
    integrationSourceSelected: {
      value: '',
      fieldName: '',
      errors: {},
      validations: [],
    },
    hostingType: {
      value: false,
      fieldName: 'On-Prem Hosting',
      errors: {},
      validations: [],
    },
    pos: {
      value: 'Vendor',
      fieldName: 'POS',
      errors: {},
      validations: [],
    },
    posSelected: {
      value: '',
      fieldName: 'Select POS',
      errors: {},
      validations: [],
    },
    onPrem: {
      value: false,
      fieldName: '',
      errors: {},
      validations: [],
    },
    resortID: {
      value: '',
      fieldName: 'Resort ID',
      errors: {},
      validations: [],
    },
    username: {
      value: '',
      fieldName: 'Username',
      errors: {},
      validations: [],
    },
    url: {
      value: '',
      fieldName: 'URL',
      errors: {},
      validations: ['required'],
    },
    password: {
      value: '',
      fieldName: 'Password',
      errors: {},
      validations: ['required'],
    },
  });

  useEffect(() => {
    if (formData.spaSelected.value && spaConfigList.length > 0) {
      const data = spaConfigList.find((spa) => spa.spaId === formData.spaSelected.value);
      setCurrData(data);
      formData.pos.value = data?.pos?.active ? 'Active' : 'Inactive';
      formData.posSelected.value = data?.pos?.id;
      setFormData(formData);
    }
  }, [formData.spaSelected]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  useEffect(() => {
    const posSelected =
      formData.pos.value === 'Active'
        ? { ...formData.posSelected, validations: ['required'] }
        : { ...formData.posSelected, validations: [] };
    setFormData({ posSelected });
  }, [formData.pos.value]);

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchAllPropertyConfigData(selectedHotel));
    }
  }, [selectedHotel]);

  const refactorPayload = () => {
    if (validate()) {
      return {
        hotelId: selectedHotel,
        spaId: formData?.spaSelected?.value,
      };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      createOrUpdateSpaReservation(refactorPayload()).then(() => {
        notificationManager('success', 'Spa details updated successfully');
        dispatch(fetchSpaList(selectedHotel));
        dispatch(fetchSpaReservationConfigs(selectedHotel));
      });
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }

      notificationManager('danger', 'Unable to update spa details');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onCheckChange = (e) => {
    const currFields = { ...formData };
    currFields.onPrem.value = e.target.checked;
    setFormData(currFields);
  };

  const onPosChange = (e) => {
    const pos = {
      value: e.target.value,
      fieldName: 'POS',
      validations: [],
      tab: 0,
    };
    setFormData({ pos });
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  const onClickSync = async (event) => {
    try {
      const res = await updateSpaSyncConfigs(selectedHotel, event.target.checked);
      dispatch(fetchAllPropertyConfigData(selectedHotel));
      notificationManager(
        res?.data?.updateSpaSyncConfig?.status ? 'success' : 'danger',
        res?.data?.updateSpaSyncConfig?.message,
      );
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className='spa-reservation' noValidate>
        <div className='col-12 hotel-service-tab-section'>
          <div className='col col-xl-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Integration Settings' />
              <Tab label='Configurable features' />
            </Tabs>
          </div>
        </div>
        {tabValue === 0 && (
          <div className='mx-4'>
            <IntegrationSource
              formData={formData}
              setFormData={setFormData}
              section='Spa Reservation'
              headTitle='Integration Source'
              onClickSync={onClickSync}
              showLoader={showLoader}
              checked={propertyConfigs?.spa?.isEnabled}
              isSyncEnabled
            />
          </div>
        )}

        {tabValue === 1 && (
          <div className='mx-4 mt-2'>
            <div className='row align-items-end'>
              <div className='col-md-10'>
                <CustomSelect
                  item={formData.spaSelected}
                  handleInputChange={(e) => {
                    setFormData({ spaSelected: e });
                  }}
                  hideNullOption={true}
                  options={
                    spas.length > 0
                      ? spas.map((spa) => {
                          return { id: spa.id, name: spa.name };
                        })
                      : [{}]
                  }
                  className='w-36'
                />
              </div>
              <div className='col-auto col-md-auto pointer' onClick={() => handleOpen()}>
                <u>
                  {configuredSpas.length}/{spaConfigList.length} Spa Configured
                </u>
              </div>
            </div>
            <div className='row mt-auto px-4 w-100 pb-5'>
              <div className='col-md-12 mt-3 d-flex justify-content-start'>
                <Button variant='contained' type='submit' color='primary' size='large'>
                  Save
                </Button>
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default SpaReservation;
